export default __webpack_public_path__ + "static/media/_PayPal.ae3feaf3.svg";